import { Stack, styled, Typography } from '@mui/material';

export const ErrorWrapper = styled(Stack)`
  height: 100vh;
  justify-content: center;
  align-items: center;
`;

export const Description = styled(Typography)`
  max-width: 540px;
  color: ${({ theme }) => theme.palette.grey[500]};
  text-align: center;
  margin-top: 1.5rem;
`;
